import { Button, Box } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { ContentHeader, Permitted, FilterButton } from 'components'

import constants from 'constants/index'
import { routes } from 'Routes'

import theme from 'theme'

const ContentHeaderMain = ({ filter }) => {
  const history = useHistory()
  return (
    <>
      <ContentHeader
        menu="Processos"
        title="Todos os processos"
        subtitle="Todos os processos"
        filter={filter}
      >
        <Box display="flex" alignItems="center" gridGap={theme.spacing(1)}>
          <Permitted tag={constants.permissions.DATA_PROCESSES.CREATE}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push(routes.dataProcess.new)}
            >
              NOVO PROCESSO
            </Button>
          </Permitted>

          <Permitted tag={constants.permissions.DATA_PROCESSES.CREATE}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push(routes.dataProcess.copy)}
            >
              COPIAR
            </Button>
          </Permitted>

          <Permitted tag={constants.permissions.DATA_PROCESSES.DESTROY}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push(routes.dataProcess.remove)}
            >
              EXCLUIR
            </Button>
          </Permitted>

          <FilterButton setDrawerOpen={filter.setDrawerOpen} />
        </Box>
      </ContentHeader>
    </>
  )
}

export default ContentHeaderMain
